module.exports = __webpack_public_path__ + "static/media/Gothita_gaussian2.d46b5307.png";